import type { TableSemanticSchema } from './types';

export const UserStorySchema: TableSemanticSchema = {
  id: 'user-story',
  name: 'User Story Map',
  description:
    'Jeff Patton user-story map — activities across the top, story rows by priority. Acceptance criteria and sprint assignment travel with each story.',
  cells: [],
  itemFields: [
    { key: 'activity', label: 'Activity', kind: 'string', required: true,
      description: 'Top-level backbone activity.' },
    { key: 'story', label: 'Story', kind: 'string', required: true },
    { key: 'priority', label: 'Priority', kind: 'enum',
      options: [
        { value: 'walking_skeleton', label: 'Walking Skeleton' },
        { value: 'mvp', label: 'MVP' },
        { value: 'release_1', label: 'Release 1' },
        { value: 'release_2', label: 'Release 2' },
      ] },
    { key: 'sprint', label: 'Sprint', kind: 'string' },
    { key: 'acceptanceCriteria', label: 'Acceptance Criteria', kind: 'string' },
    { key: 'estimate', label: 'Estimate', kind: 'number' },
  ],
  renderingHints: { layout: 'grid' },
};
